import { Datepicker } from "flowbite-react";
import moment from "moment";
import { IoCalendarClearOutline } from "react-icons/io5";
import {  MdError } from "react-icons/md";

const DefaultDatePicker = ({
  id,
  label,
  type,
  placeholder,
  required,
  name,
  labelClass,
  classnames,
  error,
  onChange,
  onBlur,
  value,
  minDate = null,
  disabled = false,
  icon,
  maxDate = false,
}) => {
  // Convert value to Date object if it's a string (YYYY-MM-DD) or leave as null
  let dateValue = null;
  if (value) {
    if (value instanceof Date) {
      dateValue = value;
    } else if (typeof value === "string" && value.length >= 8) {
      const parsed = moment(value, "YYYY-MM-DD", true);
      dateValue = parsed.isValid() ? parsed.toDate() : null;
    }
  }

  // Ensure we always pass a valid Date object or null to Datepicker
  const safeDateValue = dateValue instanceof Date && !isNaN(dateValue.getTime()) ? dateValue : null;

  // Ensure minDate and maxDate are Date objects or null
  const minDateObj = minDate ? (minDate instanceof Date ? minDate : moment(minDate, "YYYY-MM-DD").toDate()) : null;
  const maxDateObj = maxDate === true ? new Date() : (maxDate instanceof Date ? maxDate : null);

  return (
    <div className={"flex flex-col gap-1.5 relative"}>
      {label && (
        <div className="block">
          <label
            className={`text-gray-700 font-medium text-sm ${labelClass}`}
            htmlFor={id}
          >
            {label}
            {required ? <span className={"text-red-500 ml-0.5"}>*</span> : ""}
          </label>
        </div>
      )}
      <div className={`flex flex-col ${classnames || ""}`}>
        <div className={`flex flex-row items-center relative rounded-lg border border-gray-200 bg-white transition-all duration-200 hover:border-gray-300 ${
          error ? "border-red-300 bg-red-50" : ""
        } ${disabled ? "bg-gray-50 opacity-60 cursor-not-allowed" : ""}`}>
          <Datepicker
            name={name}
            {...(safeDateValue && { defaultDate: safeDateValue })}
            value={safeDateValue}
            onChange={(date) => {
              const formattedDate = date ? moment(date).format("YYYY-MM-DD") : "";
              onChange(formattedDate);
            }}
            placeholder={placeholder}
            className={`customInput !font-normal h-10 w-full z-9 rounded-lg focus:ring-2 focus:ring-primary-100
                        ${
                          error
                            ? "bg-red-50 rounded-lg"
                            : ""
                        }`}
            onBlur={onBlur}
            minDate={minDateObj}
            maxDate={maxDateObj}
            disabled={disabled}
            icon={icon}
          />
          <div
            className={`absolute right-3 text-gray-400 pointer-events-none ${
              error ? "z-10" : ""
            }`}
          >
            <IoCalendarClearOutline className="w-4 h-4" />
          </div>
        </div>
        {error ? (
          <span className="flex items-center gap-1 text-xs text-red-500 mt-1">
            <MdError className="text-sm flex-shrink-0" />
            <p>{error}</p>
          </span>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
export default DefaultDatePicker;
